import { gql } from "@apollo/client";

export const FOLDER_EXTERNAL_CHECK_UPDATED = gql`
  subscription folderExternalCheckResultUpdated($documentVerificationId: Int!) {
    folderExternalCheckResultUpdated(documentVerificationId: $documentVerificationId) {
      documentVerificationId
    }
  }
`;
